




































import { Component } from 'vue-property-decorator';
import CardFormElement from '@/components/cards/CardFormElement.vue';
import Editor from '@/components/Editor.vue';
import ElementBase from './ElementBase';

@Component({
    name: 'ElementInputText',
    components: {
        'editor': Editor,
        'card-form-element': CardFormElement,
    },
})
export default class ElementInputText extends ElementBase {
    descriptionCollapsed: boolean = false;
    placeholder: string = 'Provide a short description to point the user in the right direction';
}
